import {
  DOCUMENT_ACCEPT,
  DOCUMENT_EXTENSIONS,
  DOCUMENT_MIME_TYPES,
} from "../../constants";
import { displayErrorToast } from "@lya-protect/lya-protect-form-library/dist/UI";
import { FileInputButton, FileInputButtonProps } from "./FileInputButton";

type FileInputButtonWithDragProps = Omit<FileInputButtonProps, "onChange"> & {
  onChange: (file: File[]) => void;
};

const GENERIC_MIME_TYPES = [
  "",
  "application/octet-stream",
  "binary/octet-stream",
];

function getFileExtension(fileName: string): string {
  const dotIndex = fileName.lastIndexOf(".");
  return dotIndex >= 0 ? fileName.slice(dotIndex).toLowerCase() : "";
}

function isFileAllowed(file: File): boolean {
  const mimeType = file.type.toLowerCase();
  if (DOCUMENT_MIME_TYPES.includes(mimeType)) {
    return true;
  }
  if (GENERIC_MIME_TYPES.includes(mimeType)) {
    return DOCUMENT_EXTENSIONS.includes(getFileExtension(file.name));
  }
  return false;
}

function filterAllowedFiles(files: FileList): File[] {
  const fileArray = Array.from(files);
  const validFiles = fileArray.filter(isFileAllowed);

  if (validFiles.length < fileArray.length) {
    const rejectedCount = fileArray.length - validFiles.length;
    displayErrorToast(
      `${rejectedCount} fichier${rejectedCount > 1 ? "s" : ""} rejeté${
        rejectedCount > 1 ? "s" : ""
      } : formats autorisés : PDF, DOCX, XLSX, ODT, ODS, PNG, JPEG, WEBP, GIF, BMP, TIFF`
    );
  }

  return validFiles;
}

export function FileInputButtonWithDrag({
  onChange,
  accept = DOCUMENT_ACCEPT,
  ...props
}: FileInputButtonWithDragProps) {
  return (
    <div
      onDrop={(ev) => {
        ev.preventDefault();
        try {
          const { files } = ev.dataTransfer;
          if (!files) return;
          const validFiles = filterAllowedFiles(files);
          if (validFiles.length > 0) {
            onChange(validFiles);
          }
        } catch {
          displayErrorToast(
            "Une erreur est survenue lors de l'ajout des fichiers."
          );
        }
      }}
      onDragOver={(e) => {
        e.preventDefault();
      }}
    >
      <FileInputButton
        {...props}
        accept={accept}
        onChange={(e) => {
          const { files } = e.target;
          if (!files) return;
          onChange([...files]);
        }}
      />
    </div>
  );
}
